import { addModalOpenClass, removeModalOpenClass } from '@/utils/helper';
import React, { useEffect } from 'react';
import './DeleteConfirmModal.scss';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}
export type DeleteConfirmModalType = {
  open: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
};
const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  title = 'CONFIRM?',
  message,
  onConfirm,
  onCancel,
  confirmText = 'CONFIRM',
  cancelText = 'CANCEL',
}) => {
  useEffect(() => {
    if (isOpen) {
      addModalOpenClass();
    }
    return () => {
      removeModalOpenClass();
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay" onClick={onCancel}>
      <div
        className="delete-confirmation-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="delete-modal-icon">
          <div className="check-circle"></div>
        </div>
        <div className="delete-modal-content">
          <h3 className="delete-modal-title">{title}</h3>
          <p className="delete-modal-message">{message}</p>
        </div>
        <div className="form-actions buttons-group justify-center">
          <button className="btn btn--sm btn--pri" onClick={onConfirm}>
            {confirmText}
          </button>
          <button className="btn btn--sm btn--sec" onClick={onCancel}>
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
